import { DEFAULT_TENANT, type TenantConfig } from "@/shared/config/tenant";
import type { CurrentTenantDTO, PublicTenantBrandingDTO } from "@/shared/types/auth";

function websiteSite(url: string): string {
    try {
        return new URL(url).host;
    } catch {
        return DEFAULT_TENANT.websiteSite;
    }
}

/** Marca antes do login: só o que é público; site e moeda ficam com os da 7Days. */
export function toPublicTenantConfig(tenant: PublicTenantBrandingDTO): Partial<TenantConfig> {
    const logoUrl = tenant.logoUrl ?? DEFAULT_TENANT.logoUrl;
    return {
        id: tenant.id,
        name: tenant.name,
        logoUrl,
        logoWordmarkUrl: tenant.logoWordmarkUrl ?? tenant.logoUrl ?? DEFAULT_TENANT.logoWordmarkUrl,
        locale: tenant.locale,
    };
}

/** Campos nulos ficam com o padrão da 7Days; sem wordmark, o símbolo do tenant ocupa o lugar dele. */
export function toTenantConfig(tenant: CurrentTenantDTO): Partial<TenantConfig> {
    const logoUrl = tenant.logoUrl ?? DEFAULT_TENANT.logoUrl;
    const websiteUrl = tenant.websiteUrl ?? DEFAULT_TENANT.websiteUrl;
    return {
        id: tenant.id,
        name: tenant.name,
        logoUrl,
        logoWordmarkUrl: tenant.logoWordmarkUrl ?? tenant.logoUrl ?? DEFAULT_TENANT.logoWordmarkUrl,
        locale: tenant.locale,
        currency: tenant.currency,
        websiteUrl,
        websiteSite: websiteSite(websiteUrl),
    };
}
